<template>
  <div class="wrap talk">
		<header>
			<h1><a href="#" class="logo"></a></h1>
		</header>
		<div class="container">
			<main class="content">
				<article class="certification">
					<section class="txt agree-bg">
					</section>
					<section>
						<div class="box row row_c row_jsc">
							<span><i class="xi-check"></i></span>
							<p style="white-space:pre-wrap;">{{this.content}}</p>
						</div>
					</section>
          <!-- 버튼  -->
          <div class="btn-wrap" v-if="isAccNoExists" >
            <a
              href="javascript:void(0);"
              class="talk-btn btn-black"
              @click.stop.prevent="accNoReq"
              >계좌등록</a>
          </div>
          <!-- //버튼  -->          
				</article>
				<div class="cs-center row row_ac row_jsc b-cs">
					<span class="qa" style="font-size:0.1rem;">일반 민팃
            <span><a href="#" class="en phone" style="font-size:0.1rem;padding-left:3px;">1877-5446</a></span> 
            SKT 민팃
            <span><a href="#" class="en phone" style="font-size:0.1rem;padding-left:3px;">1877-2660</a></span> <br>
            KT 민팃
            <span><a href="#" class="en phone" style="font-size:0.1rem;padding-left:3px;">1877-4515</a></span> 
            LGU+ 민팃
            <span><a href="#" class="en phone" style="font-size:0.1rem;padding-left:3px;">1877-3943</a></span>                         
          </span>          
				</div>
			</main>
		</div>
	</div>
</template>

<script>

import Vue from 'vue'
import AppConfig from '@/config'

export default {
  name: 'SaleAgrmCncl',
  components: {},
  data: () => ({
    AppConfig: AppConfig,
    content : '판매동의 처리 중....',
    isAccNoExists : false,
    rtUrl : "talk.mintit.co.kr",
    parms: {
      ordNum : '',      
    }

  }),
  computed: {

  },
  mounted() {

    this.saleAgrmCnclInit();

   
  },
  methods: {

    async accNoReq() {
      window.location.href = this.rtUrl;
    },

    async saleAgrmCnclInit () {

      const params = {
        // 32170   G20190316065675
        ordNum : this.$route.query.ordNum,        
      }

      console.log('params ==> {}', params)

      const rtn = await Vue.httpClient
        .get('/api/purchase/pcs/mgmt/public/sale-agrm', {params} )
        .then(res => {
          if (res.data.status === AppConfig.HTTP_RESPONSE_SUCCESS) {

            if (res.data.result) {

              console.log(res.data.result)

              const rs = res.data.result;

              this.content = rs.talkMobileMsg

              if( rs.accNoReqUrl == undefined 
                  || rs.accNoReqUrl == null  
                  || rs.accNoReqUrl == "") {   //계좌번호 이미 등록 되어 있거나 필요 없는 상황

              } else { //계좌번호입력 버튼 활성화
                this.isAccNoExists = true;
                this.rtUrl = rs.accNoReqUrl;
              }
            } else {
              //Vue.Alert.alert("구매 데이터가 없습니다.")  
               this.content = '판매이력이 없습니다.'
            }
          } else {
            // alert("1111")

             this.content = '통신오류입니다.'
          }
        })

    },    

  }
}
</script>



// WEBPACK FOOTER //
// src/views/purchase/SaleAgrm.vue